// extracted by mini-css-extract-plugin
export default {"root":"_3tAW4","icon":"yEDev","tooltip":"_1jU6Y"};